import FormatCurrency from "../../../../src/components/jstools/FormatCurrency";
import * as React from 'react';
export default {
  FormatCurrency,
  React
};